import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

import { reducer as persistence } from '../lib/MetagnosticDuck/persistence'
import ui from '../reducers/ui'

import tripsDuck from '../ducks/trips'
import activitiesDuck from '../ducks/activities'
import productsDuck from '../ducks/products'
import citiesDuck from '../ducks/cities'
import expensesDuck from '../ducks/expenses'
import usersDuck from '../ducks/users'
import routesDuck from '../ducks/routes'
import tasksDuck from '../ducks/tasks'
import blocksDuck from '../ducks/blocks'
import suppliersDuck from '../ducks/suppliers'
import tagsDuck from '../ducks/tags'
import reservationsDuck from '../ducks/reservations'
import appDocsDuck from '../ducks/appDocs'
import ActionTypes from '../actions/ActionTypes';

function loginData(state = {}, action) {
  if (action.type == "LOGIN_DATA") {
    return action.data
  }
  else return state
}

/**
 * caches the last 10 locations
 */
// @TODO check if this historyCache should have more paths
// #TODO i'm sure this could be done just with redux-router's reducer, instead of adding a new one
function historyCache(
  state = { 
    oper: "/private/oper", 
    activities: "/private/activities", 
    blocks: "/private/blocks",
    suppliers: "/private/suppliers"
  }, 
  action: { type: string, payload: Object }
) {
  if (!action) return {}
  
  if (action.type === "@@router/LOCATION_CHANGE" && action.payload) {
    const path = action.payload.pathname + action.payload.search + action.payload.hash

    if (path.match(/^\/private\/oper.*/))       return { ...state, oper:       path }
    if (path.match(/^\/private\/blocks.*/))     return { ...state, blocks:     path }
    if (path.match(/^\/private\/activities.*/)) return { ...state, activities: path }
    if (path.match(/^\/private\/suppliers.*/))  return { ...state, suppliers:  path }
  }
  
  return state
}

function permissionsReducer(state = {}, action) {
  if (action.type == ActionTypes.GET_PERMISSIONS) {
    return action.payload
  }
  else return state
}

const reducer = combineReducers({
  activities: activitiesDuck.reducer, 
  products: productsDuck.reducer, 
  cities: citiesDuck.reducer, 
  expenses: expensesDuck.reducer,  
  users: usersDuck.reducer,
  tasks: tasksDuck.reducer, 
  routes: routesDuck.reducer, 
  blocks: blocksDuck.reducer, 
  trips: tripsDuck.reducer, 
  suppliers: suppliersDuck.reducer, 
  tags: tagsDuck.reducer,
  reservations: reservationsDuck.reducer, 
  appdocs: appDocsDuck.reducer, 
  
  permissions: permissionsReducer,

  persistence,
  loginData,
  routing: routerReducer,
  historyCache,
  ui, 
})

export default reducer
